export const VITO_APP_ID = "starwalk-site";
export const SW_VERSION = "2";
export const SW_PATH = "/public/push/ossdksw.js";
export const SWCommands = {
    GetWorkerVersion: "GetWorkerVersion",
    CheckWorkerVersion: "CheckWorkerVersion",
};
export const STORAGE_DB_NAME = "VTPushSubscription";
export const STORAGE_DB_VERSION = 1;
